// dev-doc: 2026-09-17 18:45 smjs-canvas-map-rotation
// Ported from scribblemaps.com/assets/views/create/scripts/layers.js so lite offers the SAME base
// layers and data overlays as /create. Only the export differs: lite loads this as a plain script
// and calls window.createLayers, where create declares a local var.
// The source is MIXED encoding - mostly UTF-8 with the odd bare cp1252 byte - so it is repaired
// per sequence on the way in. Decoding the whole file as cp1252 turns every valid UTF-8 (c) into
// mojibake in the attribution strings.
// dev-doc: 2026-09-16 00:18 smjs-tileserver-vector-rendering

var mapBoxAtt =

  "© <a href='https://www.mapbox.com/map-feedback/'>Mapbox</a> © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>";

var osmAtt = "© <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>";

var mapTiler = "© <a href='https://www.maptiler.com'>Map Tiler</a>" + " <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>";

var mbtoken = 'pk.eyJ1Ijoiam9uYXRoYW53YWduZXIiLCJhIjoiZ1V5YVNwUSJ9.Rh9CMNgUd8odMnnwNFHZfg';


var smLayers = {};

window.smLayers = smLayers;



var mbBase = [

  {

    id: 'mbb_hybrid',

    label: 'Hybrid',

    copyright: mapBoxAtt,

    stack: ['//scribblemaps.io/tms/layers/mt_hybrid/{x}/{y}/{z}.png']

  },

  {

    id: 'mbb_road',

    label: 'Road',

    copyright: osmAtt,

    maxZoom: 25

  },

  {

    id: 'mbb_road_v2',

    label: 'Road V2',

    copyright: osmAtt,

    stack: [

      '//scribblemaps.io/tms/layers/mbb_road_v2/{x}/{y}/{z}.png'

    ]

  },

  {

    id: 'mbb_road_v2_nolabel',

    label: 'Road V2 No Label',

    copyright: osmAtt,

    stack: [

      '//scribblemaps.io/tms/layers/mbb_road_v2_nolabel/{x}/{y}/{z}.png'

    ]

  },

  {

    id: 'mbb_satellite',

    label: 'Satellite',

    copyright: '©ESRI - Map Data',

    stack: ['//scribblemaps.io/tms/layers/esri_satellite/{x}/{y}/{z}.png']

  },

  {

    id: 'mbb_terrain',

    label: 'Terrain',

    copyright: osmAtt,

    stack: ['//scribblemaps.io/tms/layers/sm_topo/{x}/{y}/{z}.png']

  }

];



smLayers['base'] = mbBase;



var defaultBase = [

  {

    id: 'hybrid',

    label: 'Hybrid'

  },

  {

    id: 'road',

    label: 'Road'

  },

  {

    id: 'satellite',

    label: 'Satellite'

  },

  {

    id: 'terrain',

    label: 'Terrain'

  },

  {

    id: 'traffic',

    label: 'Traffic'

  }

];



smLayers['ng'] = [

  {

    copyright: '©National Geographic ©ESRI - Map Data',

    stack: ['https://server.arcgisonline.com/ArcGIS/rest/services/NatGeo_World_Map/MapServer/tile/{z}/{y}/{x}'],

    label: 'Education',

    id: 'ng_base',

    maxZoom: 16

  }

];



smLayers['eu'] = [

  {

    copyright: "© <a href='https://www.emodnet-bathymetry.eu'>EMODnet Bathymetry</a>",

    stack: ['//scribblemaps.io/tms/layers/eu_edobath/{x}/{y}/{z}.png'],

    label: 'Bathmetry',

    id: 'eu_edobath'

  }

];



smLayers['osm'] = [

  {

    copyright: "© <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    // No raster stack: this resolves through VectorBaseMapStyles over the owned world vector
    // tiles, like sm_prism/sm_pirate/sm_custom_osm above. The raster URL it used to carry pointed
    // at a tile-server DESIGN that no longer exists - every zoom answered {"error":"not_found"} -
    // so the fallback could only ever render blank.

    label: 'SM ROAD',

    id: 'osm_mapnik'

  },

  {

    copyright: "© <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    // Cycle resolves through VectorBaseMapStyles over the owned world vector tiles.

    maxZoom: 25,

    label: 'Cycle',

    id: 'osm_cycle'

  }

];



smLayers['mbb'] = [

  /* {

        id: "mbb_hybrid",

        label: "Hybrid",

        copyright: mapBoxAtt,

        stack: ["//api.mapbox.com/styles/v1/mapbox/satellite-streets-v9/tiles/256/{z}/{x}/{y}@2x?access_token=" + mbtoken]

        //api.maptiler.com/maps/bright/{z}/{x}/{y}@2x.png?key=NqZrAc6tR2JSRCD1UeZ3

    }, */

  {

    id: 'mbb_road',

    label: 'Road',

    copyright: osmAtt,

    maxZoom: 25

  },

  {

    id: 'mbb_road_v2',

    label: 'Road V2',

    copyright: osmAtt,

    stack: [

      '//scribblemaps.io/tms/layers/mbb_road_v2/{x}/{y}/{z}.png'

    ]

  },

  {

    id: 'mbb_road_v2_nolabel',

    label: 'Road V2 No Label',

    copyright: osmAtt,

    stack: [

      '//scribblemaps.io/tms/layers/mbb_road_v2_nolabel/{x}/{y}/{z}.png'

    ]

  },

  {

    id: 'mbb_satellite',

    label: 'Satellite',

    copyright: '©ESRI - Map Data',

    stack: ['//scribblemaps.io/tms/layers/esri_satellite/{x}/{y}/{z}.png']

  },

  {

    id: 'mb_satellite',

    label: 'Satellite',

    copyright: mapBoxAtt,

    stack: ['//scribblemaps.io/tms/layers/mb_satellite/{x}/{y}/{z}.png']

  },

  {

    id: 'mbb_terrain',

    label: 'Terrain',

    copyright: mapBoxAtt,

    stack: ['//scribblemaps.io/tms/layers/mbb_terrain/{x}/{y}/{z}.png']

  },

  {

    id: 'mbb_bath',

    label: 'Ocean',

    copyright: osmAtt,

    stack: ['https://api.maptiler.com/maps/ocean/256/{z}/{x}/{y}@2x.png?key=UpweakXS0iBgsernxgfH']

  },

  {

    copyright: osmAtt,

    stack: ['//scribblemaps.io/tms/layers/mbb_worldstreet/{x}/{y}/{z}.png'],

    label: 'World Street',

    id: 'mbb_worldstreet'

  }

];



smLayers['esri'] = [

  {

    copyright: '<span style="color: #FFFFFF">©ESRI - Map Data</span>',

    stack: ['//scribblemaps.io/tms/layers/esri_satellite/{x}/{y}/{z}.png'],

    label: 'Satellite',

    id: 'esri_satellite'

  },

  {

    copyright: osmAtt,

    stack: ['//scribblemaps.io/tms/layers/mbb_worldstreet/{x}/{y}/{z}.png'],

    label: 'World Street',

    id: 'esri_worldstreet'

  },

  {

    copyright: mapBoxAtt,

    stack: ['//scribblemaps.io/tms/layers/mbb_terrain/{x}/{y}/{z}.png'],

    label: 'Physical',

    id: 'esri_physical'

  },

  {

    copyright: mapBoxAtt,

    stack: ['//scribblemaps.io/tms/layers/mbb_terrain/{x}/{y}/{z}.png'],

    label: 'Topography',

    id: 'esri_topo'

  }

];



smLayers['blank'] = [

  {

    copyright: '',

    stack: ['https://cdn.scribblemaps.com/assets/tiles/grid.png?v5'],

    label: 'Grid',

    maxZoom: 25,

    id: 'sm_grid_grey'

  },

  {

    copyright: '',

    stack: [

      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII='

    ],

    label: 'White',

    maxZoom: 25,

    id: 'sm_white'

  },

  {

    copyright: '',

    stack: [

      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mM88x8AAp0BzdNtlUkAAAAASUVORK5CYII='

    ],

    label: 'Grey',

    maxZoom: 25,

    id: 'sm_grey'

  },

  {

    copyright: '',

    stack: [

      'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNM+w8AAdEBZxIy2ZkAAAAASUVORK5CYII='

    ],

    label: 'Dark Grey',

    maxZoom: 25,

    id: 'sm_darkGrey'

  },

  {

    copyright: '',

    stack: ['data:image/gif;base64,R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs='],

    label: 'Black',

    maxZoom: 25,

    id: 'sm_black'

  },

  {

    copyright: '',

    stack: [''],

    label: 'Custom',

    maxZoom: 25,

    id: 'sm_custom'

  }

];



smLayers['poster'] = [

  {

    copyright: mapBoxAtt,

    stack: ['//scribblemaps.io/tms/layers/mb_bw/{x}/{y}/{z}.png'],

    label: 'B&W',

    id: 'mb_bw'

  },

  {

    copyright: mapTiler,

    stack: ['//scribblemaps.io/tms/layers/mb_bwlbl/{x}/{y}/{z}.png'],

    label: 'B&W label',

    id: 'mb_bwlbl'

  }

];



smLayers['sm_base'] = [

  { id: 'sm_road_v2', label: 'SM ROAD', copyright: osmAtt, maxZoom: 25 },

  { id: 'sm_vector', label: 'OpenStreetMap', copyright: osmAtt, maxZoom: 25 },

  { id: 'sm_light', label: 'Light', copyright: osmAtt, maxZoom: 25 },

  { id: 'sm_dark', label: 'Dark', copyright: osmAtt, maxZoom: 25 },

  { id: 'sm_grayscale', label: 'Grayscale', copyright: osmAtt, maxZoom: 25 },

  { id: 'sm_prism', label: 'Prism', copyright: osmAtt, maxZoom: 25 },
  { id: 'sm_pirate', label: 'Pirate', copyright: osmAtt, maxZoom: 25 },

  { id: 'sm_custom_osm', label: 'Custom', copyright: osmAtt, maxZoom: 25 },

  {

    copyright: "© <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    // No raster stack: this resolves through VectorBaseMapStyles over the owned world vector
    // tiles, like sm_prism/sm_pirate/sm_custom_osm above. The raster URL it used to carry pointed
    // at a tile-server DESIGN that no longer exists - every zoom answered {"error":"not_found"} -
    // so the fallback could only ever render blank.

    label: 'Road',

    id: 'sm_road',

    maxZoom: 22

  },

  {

    copyright: "© <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    stack: ['https://scribblemaps.io/tms/layers/sm_topo/{x}/{y}/{z}.png'],

    label: 'Topo',

    id: 'sm_topo',

    maxZoom: 15

  }

];



smLayers['noaa'] = [

  {

    copyright: '©NOAA',

    stack: ['//tileservice.charts.noaa.gov/tiles/50000_1/{z}/{x}/{y}.png'],

    label: 'Nautical',

    id: 'noaa_nautical',

    maxZoom: 11

  }/*,

  {

    copyright: '©FAA',

    stack: ['//wms.chartbundle.com/tms/v1.0/sec/{z}/{x}/{y}.png?type=google'],

    label: 'VFR',

    id: 'faa_vfr',

    maxZoom: 13

  }*/

];



smLayers['stm'] = [

  {

    copyright: "By Stamen Design © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    stack: ['//scribblemaps.io/xyz/layers/stm_terrain/{x}/{y}/{z}.jpg'],

    label: 'Terrain',

    id: 'stm_terrain',

    maxZoom: 15

  },

  {

    copyright: "By Stamen Design © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    stack: ['//scribblemaps.io/xyz/layers/stm_toner/{x}/{y}/{z}.png'],

    label: 'Toner',

    id: 'stm_toner',

    maxZoom: 15

  },

  {

    copyright: "By Stamen Design © <a href='http://www.openstreetmap.org/copyright'>OpenStreetMap</a>",

    stack: ['//scribblemaps.io/xyz/layers/stm_watercolor/{x}/{y}/{z}.jpg'],

    label: 'Watercolor',

    id: 'stm_watercolor',

    maxZoom: 15

  }

];



smLayers['astral'] = [

  {

    copyright: 'Image Credit: DSS Consortium, SDSS, NASA/ESA ©Google',

    stack: [

      '//mw1.google.com/mw-planetary/sky/skytiles_v1/[X]_[Y]_[Z].jpg',

      '//mw2.google.com/mw-planetary/sky/skytiles_v1/[X]_[Y]_[Z].jpg',

      '//mw2.google.com/mw-planetary/sky/skytiles_v1/[X]_[Y]_[Z].jpg'

    ],

    label: 'Night Sky',

    maxZoom: 13,

    id: 'goog_nightSky'

  },

  {

    copyright: '',

    stack: [

      '//scribblemaps.io/xyz/layers/space_moon/{x}/{-y}/{z}.jpg?v2'

    ],

    label: 'Moon',

    maxZoom: 9,

    id: 'space_moon'

  },

  {

    copyright: '',

    stack: [

      '//scribblemaps.io/xyz/layers/space_moon_hybrid/{x}/{y}/{z}.jpg'

    ],

    label: 'Moon Hybrid',

    maxZoom: 22,

    id: 'space_moon_hybrid'

  },

  {

    copyright: '',

    stack: [

      '//scribblemaps.io/xyz/layers/space_mars/{x}/{-y}/{z}.jpg'

    ],

    label: 'Mars',

    maxZoom: 5,

    id: 'space_mars'

  },

  {

    copyright: '',

    stack: [

      '//scribblemaps.io/xyz/layers/space_mars_hybrid/{x}/{y}/{z}.jpg'

    ],

    label: 'Mars Hybrid',

    maxZoom: 22,

    id: 'space_mars_hybrid'

  }

];



/* var gibsURL = 'https://gibs.earthdata2.nasa.gov/wmts/epsg3857/best/';

smLayers["nasa"] = [

    {

        copyright: "NASA",

        stack: [gibsURL + "/MODIS_Terra_CorrectedReflectance_TrueColor/default/2017-03-13/GoogleMapsCompatible_Level22/{z}/{y}/{x}.png"],

        label: "Aerial",

        id: "nasa_aerial"

    }

]; */



var isMapbox = function (typeId) {

  for (var s in smLayers) {

    for (var i = 0; i < smLayers[s].length; i++) {

      if (smLayers[s][i].id == typeId) {

        if (smLayers[s][i].stack) {

          for (var j = 0; j < smLayers[s][i].stack.length; j++) {

            if (smLayers[s][i].stack[j].indexOf('mapbox') != -1) {

              return true;

            }

          }

        }

      }

    }

  }



  return false;

};



var getGroupId = function (typeId) {

  for (var s in smLayers) {

    for (var i = 0; i < smLayers[s].length; i++) {

      if (smLayers[s][i].id == typeId) {

        return s;

      } else if (smLayers[s][i].id.indexOf('custom_style') != -1 && typeId.indexOf('custom_style') != -1) {

        smLayers[s][i].id = typeId;

        return s;

      }

    }

  }



  if (typeId== "sm_custom") {

    smLayers['blank'].push({

      label: "Custom",

      id: typeId

    });



    return 'blank';

  }



  if (typeId == 'custom_style' || typeId == 'custom_style_hybrid') {

    smLayers['base'].push({

      label: 'Custom',

      id: typeId

    });



    return 'base';

  } else if (typeId == 'userXYZ') {

    smLayers['sm_base'].push({

      label: 'User XYZ',

      id: 'userXYZ'

    });



    return 'base';

  }



  return null;

};



window['createLayers'] = function (sm, useGoogle) {

  if (window.useGoogle || window.useBing || window.useEsri) {

    smLayers['base'] = defaultBase;

  }



  var labels = {

    'base': 'Google',

    'ng': 'National Geographic',

    'osm': 'Open Street Map',

    'stm': 'Stamen',

    'mbb': 'Base',

    'esri': 'ESRI',

    'blank': 'Blank',

    'poster': 'Poster',

    'sm_base': 'Scribble Maps &amp; OSM',

    'noaa': 'NOAA',

    'astral': 'Space'

  };

  var mapDataLayers = {

    'maps': [

      {

        name: 'Base',

        layers: [

          { id: 'hybrid', label: 'Hybrid' },

          { id: 'road', label: 'Road' },

          { id: 'satellite', label: 'Satellite' },

          { id: 'terrain', label: 'Terrain' },

          { id: 'traffic', label: 'Traffic' }

        ]

      },

      {

        name: 'Scribble Maps &amp; OSM',

        cc: 'bya',

        layers: [

          { id: 'sm_road_v2', label: 'SM ROAD' },

          { id: 'sm_road', label: 'OSM Road' },

          { id: 'sm_grayscale', label: 'Grayscale' },

          { id: 'sm_custom_osm', label: 'Custom' },

          { id: 'sm_topo', label: 'Topo' },

          { id: 'osm_cycle', label: 'Cycle' },

          { id: 'mbb_road', label: 'Road' },

          { id: 'mbb_terrain', label: 'Terrain' },

          { id: 'worldGenerator', label: 'Fictional' }

        ]

      },

      {

        name: 'Pattern/Color',

        layers: [

          { id: 'sm_custom', label: "Set Custom" },

          { id: 'sm_white', label: 'White' },

          { id: 'sm_grey', label: 'Grey' },

          { id: 'sm_black', label: 'Black' },

          { id: 'sm_grid_grey', label: 'Grid' }

        ]

      },

      {

        name: 'Other',

        layers: [

          { id: 'mbb_worldstreet', label: 'World Street' },

          { id: 'ng_base', label: 'Education' },

          //{ id: 'faa_vfr', label: 'FAA VFR' },

          { id: 'mb_bw', label: 'Poster' },

          { id: 'mb_bwlbl', label: 'B&W Label' },

          { id: 'esri_satellite', label: 'ESRI Sat' },

          { id: 'eu_edobath', label: 'EU Ocean' },

          { id: 'mbb_bath', label: 'SM Ocean' }

        ]

      },

      {

        name: 'Space!',

        layers: [

          { id: 'space_moon', label: 'Moon' },

          { id: 'space_moon_hybrid', label: 'Moon Hybrid' },

          { id: 'space_mars', label: 'Mars' },

          { id: 'space_mars_hybrid', label: 'Mars Hybrid' }

        ]

      }

    ],

    'data': [

      {

        'id': 'sm_parcel',

        'title': 'USA Parcel',

        'about': 'National Parcel Data',

        'layers': ['parcels'],

        'proRequired': 'business'

      },

      {

        'id': 'sm_usaDemo',

        'title': 'USA Demographics',

        'url': 'https://www.scribblemaps.io/services/census-tracts/tiles/{x}/{y}/{z}.pbf',

        'about': 'By Tract (ACS-5 2024)',

        'layers': ['us-census-tracts-2024', 'us-census-tracts-2024_label']

      },

      {

        'id': 'sm_zcta',

        'url': 'https://www.scribblemaps.io/services/zcta/tiles/{x}/{y}/{z}.pbf',

        'title': 'USA Zip Codes',

        'about': 'Zip Code Areas',

        'layers': ['zcta', 'zcta_label'],

        'iconClass': 'sm_zcta'

      }

    ]

  };



  if (window.hasSatellite) {

    mapDataLayers.data.unshift({

      'id': 'sm_imagery',

      'title': 'Aerial Imagery',

      'about': 'Purchase &amp; Manage',

      'action': 'buySatellite'

    });

  }



  // mapDataLayers.data.unshift({

  //   'id': 'sm_foot_traffic',

  //   'title': 'Foot Traffic Flow',

  //   'about': 'Where People Are',

  //   'action': 'openFootTraffic'

  // });



  mapDataLayers.data.unshift({

    'id': 'sm_insights',

    'title': 'Discover insights',

    'about': 'Analyze &amp; Score Locations',

    'action': 'openInsights'

  });



  for (var s in smLayers) {

    if (s == 'esri') {

      z = 19;

    } else if (s == 'mb' || s == 'mbb' || s == 'poster') {

      z = 20;

    } else {

      z = null;

    }



    for (var i = 0; i < smLayers[s].length; i++) {

      if (smLayers[s][i].stack != null) {

        if (window.environment == 'local') {

          smLayers[s][i].stack[0] = smLayers[s][i].stack[0].replace('//www.scribblemaps.com/', '/');

        }

        sm.layers.createTileLayer(

          smLayers[s][i].id,

          smLayers[s][i].stack,

          smLayers[s][i].maxZoom || z,

          smLayers[s][i].label + ' (' + smLayers[s][i].id + ')',

          smLayers[s][i].copyright,

          smLayers[s][i].vector

        );

      }

    }

  }



  if (window['scribbleMagic']) {

    mapDataLayers['magic'] = {

      styles: [

        { id: 'pirate', title: 'Pirate', prompt: 'Transform this map into an old pirate treasure map with aged parchment texture, hand-drawn coastlines, compass roses, and nautical illustrations', thumbnail: 'e3eed560-00d6-46f7-b914-39d884cfb9c7', category: 'style', examples: ['3d957bcd-2575-4c12-be68-b19c1ccd52ec'], clipX: 7, clipY: 7, demoLat: 10.42416695, demoLng: -75.54749682, demoZoom: 16, demoMapType: 'mbb_road_v2_nolabel' },

        { id: 'night', title: 'Night', prompt: 'Convert to satellite imagery and then convert to night time', thumbnail: '3d39189d-f77d-49dd-8bcf-3f94f0567576', category: 'style', examples: ['2668731c-349c-415b-97dd-cae4f1b1d2e6', '3d39189d-f77d-49dd-8bcf-3f94f0567576'], demoLat: 43.64325276, demoLng: -79.3919138, demoZoom: 16, demoMapType: 'sm_black' },

        { id: 'wedding', title: 'Wedding', prompt: 'A map for a wedding invitation complete with border', thumbnail: '4788af52-5033-4858-be9f-8d7fba37b2c1', category: 'style', examples: ['4788af52-5033-4858-be9f-8d7fba37b2c1'], clipX: 5, clipY: 5, demoLat: 42.88182726, demoLng: -78.87847164, demoZoom: 15, demoMapType: 'mbb_road_v2_nolabel' },

        { id: 'festival', title: 'Festival', prompt: 'Plan me a festival', thumbnail: '620df70c-4dc4-42d2-8a68-e7d81fecea5d', category: 'create', examples: ['620df70c-4dc4-42d2-8a68-e7d81fecea5d'], demoLat: 40.7739813, demoLng: -73.97091734, demoZoom: 20.537318840227464, demoMapType: 'mbb_road_v2_nolabel' },

        { id: 'brochure', title: 'Brochure', prompt: 'Transform this map into a vibrant, digitally illustrated form of theme park cartography utilizing an isometric, pseudo-3D bird\'s-eye perspective. The style is characterized by highly saturated, optimistic colors—specifically lush greens and bright blues—and clean, polished rendering with smooth gradients and sharp edges. Its most defining feature is its deliberately exaggerated scale; major landmarks are drawn massively oversized to establish an immediate visual hierarchy, while the surrounding landscapes and infrastructure are rendered in a simplified, cartoon-lite realism.', thumbnail: 'a340d8d4-ce1c-4fea-b694-30d0a85f991a', category: 'style', examples: ['a340d8d4-ce1c-4fea-b694-30d0a85f991a'], clipX: 3, clipY: 1, demoLat: 25.03563819, demoLng: 121.55612373, demoZoom: 16, demoMapType: 'mbb_road_v2_nolabel' },

        { id: 'cyberpunk', title: 'Cyberpunk', prompt: 'Transform this map into a cyberpunk cityscape with neon lights, holographic signs, futuristic vehicles, and a rain-soaked dystopian atmosphere', thumbnail: '8297667d-e6ee-413d-8f3b-511925831af3', category: 'style', examples: ['8297667d-e6ee-413d-8f3b-511925831af3'], clipX: 3, clipY: 3, demoLat: 37.79138806, demoLng: -122.39936905, demoZoom: 16.5, demoMapType: 'sm_black' },

        { id: 'anime', title: 'Anime', prompt: 'Anime Style', thumbnail: '6ccc2c83-dfc7-4df2-878e-ef91c0758a93', category: 'style', examples: ['6ccc2c83-dfc7-4df2-878e-ef91c0758a93'], demoLat: 41.87609101, demoLng: -87.62580422, demoZoom: 15, demoMapType: 'sm_white' },

        /* { id: 'winter', title: 'Winter', prompt: 'Transform this map into a winter wonderland with snow-covered streets, frosted buildings, and a cold blue atmosphere', thumbnail: '7f71bae2-45dc-4733-8fcd-ecf60ebfbb4c', category: 'style', examples: ['7f71bae2-45dc-4733-8fcd-ecf60ebfbb4c'], demoLat: 26.70356954, demoLng: -80.04093848, demoZoom: 16.94, demoMapType: 'sm_white' }, */

        /* { id: 'isometric', title: 'Isometric', prompt: 'An isometric vector style architectural visualization of a mixed-use urban development. Buildings are represented as clean geometric masses. Landscaping is rendered in pale pastel greens and muted sage tones, with simple stylized spherical trees. Soft, diffused ambient lighting, no harsh shadows, clean aesthetic, high angle view.', thumbnail: 'e3607dd6-8745-4abc-9109-72e78723a1a0', category: 'style', examples: ['e3607dd6-8745-4abc-9109-72e78723a1a0'], clipX: 1, clipY: 6 }, */

        /* { id: 'tourism', title: 'Tourism', prompt: 'Transform this map into a colorful tourism-style illustrated map with landmarks, icons, and a friendly hand-drawn aesthetic', thumbnail: '5fe9ebf7-dd06-47e3-afbb-30717c94ca9f', category: 'style', examples: ['5fe9ebf7-dd06-47e3-afbb-30717c94ca9f'] }, */

        { id: 'cottoncandy', title: 'Cotton Candy', prompt: 'Transform this map into a cotton candy themed world with soft pastel pinks, blues, and purples, fluffy cloud-like textures, and dreamy whimsical atmosphere', thumbnail: 'c26e6e9c-d247-4e40-8cb4-cba4bd2334cb', category: 'style', examples: ['c26e6e9c-d247-4e40-8cb4-cba4bd2334cb'], demoLat: 42.33147801, demoLng: -83.04547012, demoZoom: 15.687676166500935, demoMapType: 'sm_black' },

        /* { id: 'comic', title: 'Comic', prompt: 'Transform this map into a comic book style with bold black outlines, halftone dot shading, vibrant pop-art colors, and dramatic action-style effects', thumbnail: '39decd4a-726f-4c3c-ae5b-fb08fa4a10f6', category: 'style', examples: ['39decd4a-726f-4c3c-ae5b-fb08fa4a10f6'], demoLat: 11.01607082, demoLng: -74.83393214, demoZoom: 14, demoMapType: 'mbb_road' }, */

        { id: 'fantasy', title: 'Fantasy', prompt: 'Transform this map into a fantasy RPG-style map with hand-drawn mountains, enchanted forests, medieval castles, and a weathered parchment look', thumbnail: 'a73fc506-c3c3-4d53-869b-29cc8eade05a', category: 'style', examples: ['a73fc506-c3c3-4d53-869b-29cc8eade05a'], clipX: 1, clipY: 2, demoLat: 37.67536579, demoLng: -97.32340789, demoZoom: 20, demoMapType: 'sm_black' },

        { id: 'felt', title: 'Felt', prompt: 'Make everything felt', thumbnail: '95ce02bd-d110-498b-87c2-6a0f65ef076d', category: 'style', examples: ['95ce02bd-d110-498b-87c2-6a0f65ef076d'], demoLat: -33.86557208, demoLng: 151.19201229, demoZoom: 15, demoMapType: 'mbb_road_v2_nolabel' },

      ],

      markers: [

        { id: 'marker_coffee', title: 'Marker Coffee', prompt: 'Create me a pin with a coffee cup on top', thumbnail: '9615df7d-209e-4fb7-93fe-41b77429ee79', category: 'marker', examples: ['9615df7d-209e-4fb7-93fe-41b77429ee79'], markerId: '9615df7d-209e-4fb7-93fe-41b77429ee79', demoLat: 42.98291405, demoLng: -81.23130785, demoZoom: 15, demoMapType: 'sm_grid_grey' },

        { id: 'marker_snowplow', title: 'Snow Plow', prompt: 'Create an isometric snow plow', thumbnail: '6800d7e6-6bcb-41c3-a04d-1fd067a28e6a', category: 'marker', examples: ['6800d7e6-6bcb-41c3-a04d-1fd067a28e6a'], demoLat: 42.98291405, demoLng: -81.23130785, demoZoom: 15, demoMapType: 'sm_grid_grey' },

        { id: 'marker_bestdeal', title: 'Best Deal Ever Sign', prompt: 'Create a best deal ever sign', thumbnail: '9ac5d0e6-59f8-4bc7-8b3f-c60d77c7ef9e', category: 'marker', examples: ['9ac5d0e6-59f8-4bc7-8b3f-c60d77c7ef9e'], demoLat: 42.98291405, demoLng: -81.23130785, demoZoom: 15, demoMapType: 'sm_grid_grey' },

        { id: 'marker_restaurants', title: 'Best Restaurants Here', prompt: 'Create a best restaurants here sign', thumbnail: '9a05161b-32d8-4982-a863-399aebd0346b', category: 'marker', examples: ['9a05161b-32d8-4982-a863-399aebd0346b'], demoLat: 42.98291405, demoLng: -81.23130785, demoZoom: 15, demoMapType: 'sm_grid_grey' },

        { id: 'marker_barchart', title: 'Bar Chart', prompt: 'Isometric 3 solid bars beside each other showing Commercial: 50% Industrial: 40% Residential: 10%', thumbnail: 'dcbcf05d-054d-4c86-983b-08962e170c5d', category: 'marker', examples: ['dcbcf05d-054d-4c86-983b-08962e170c5d'], demoLat: 42.98291405, demoLng: -81.23130785, demoZoom: 15, demoMapType: 'sm_grid_grey' }

      ],

      models: [

        { id: 'palmtree', title: 'Palm Tree', prompt: 'A detailed 3D palm tree model with realistic trunk and lush green fronds', thumbnail: '/assets/views/create/images/magic/palm.gif', category: 'model', modelId: 'd8ede299-8bb8-440f-8138-8d199bbee656', width: 2, demoLat: 40.71255181, demoLng: -74.00621151, demoZoom: 20, demoMapType: 'satellite' },

        { id: 'tent', title: 'Tent', prompt: 'A detailed 3D tent model positioned on the terrain as if set up for camping', thumbnail: '/assets/views/create/images/magic/tent.gif', category: 'model', modelId: '0becf86a-e5d5-49c9-8fcc-89b02d2406a3', width: 3, demoLat: 40.71255181, demoLng: -74.00621151, demoZoom: 20, demoMapType: 'satellite' },

        { id: 'car', title: 'Car', prompt: 'A detailed 3D car model with realistic proportions and clean design', thumbnail: '/assets/views/create/images/magic/car.gif', category: 'model', modelId: 'a83adce9-8984-44b1-bba3-3bf9f880235c', width: 2, demoLat: 40.71255181, demoLng: -74.00621151, demoZoom: 20, demoMapType: 'satellite' },

        { id: 'dragon', title: 'Dragon', prompt: 'A detailed 3D dragon model with dramatic wings spread and fire-breathing effects', thumbnail: '/assets/views/create/images/magic/dragon.gif', category: 'model', modelId: '674f24b8-4079-49e9-9879-0655fa455305', width: 20, demoLat: 40.71255181, demoLng: -74.00621151, demoZoom: 20, demoMapType: 'satellite' },

        { id: 'ufo', title: 'UFO', prompt: 'A detailed 3D UFO model hovering with dramatic lighting and alien atmosphere', thumbnail: '/assets/views/create/images/magic/ufo.gif', category: 'model', modelId: 'c52ebabb-b446-46a8-9087-00fbb980abca', width: 15, demoLat: 40.71255181, demoLng: -74.00621151, demoZoom: 20, demoMapType: 'satellite' }

      ]

    };

  }



  sm.layers.setMapDataLayers(mapDataLayers);

};

